import * as React from 'react';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import { ApiService } from '../../../services/api_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

export interface CheckJunkDataState {
    showSpinner: boolean;
    junkData: any;
    jsonObj: string;
}

export class CheckJunkData extends React.Component<{}, CheckJunkDataState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showSpinner: false,
            junkData: null,
            jsonObj: null
        };
        this.findJunkData = this.findJunkData.bind(this);
        this.cleanJunkData = this.cleanJunkData.bind(this);
        this.findEnergiedatenMitFehlendemStandort = this.findEnergiedatenMitFehlendemStandort.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;

    componentDidMount(): void {

    }

    componentDidUpdate(prevProps: Readonly<{}>, prevState: Readonly<CheckJunkDataState>, snapshot?: any): void {
        if (this.state.showSpinner && !prevState.showSpinner) {
            this.setState({ junkData: null, jsonObj: null });
        }
    }

    render(): JSX.Element {
        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <WActionButton
                        label='Junk-Daten suchen'
                        insideText='Junk-Daten suchen'
                        tooltip='Junk-Daten suchen'
                        key='findJunkData'
                        action='suche'
                        onAction={this.findJunkData}
                    />
                    {/* Siehe: WKETOOL-227
                    <WActionButton
                        label='Junk-Daten enfernen'
                        insideText='Junk-Daten enfernen'
                        tooltip='Junk-Daten enfernen'
                        key='delJunkData'
                        action='delete'
                        onAction={() => {
                            if (window.confirm('Sind Sie sicher, dass Sie diese Junk-Daten löschen möchten?')) {
                                this.cleanJunkData();
                            }
                        }}
                    /> */}
                    <WActionButton
                        label='Energiedaten mit fehlendem Standort suchen'
                        insideText='Energiedaten mit fehlendem Standort suchen'
                        tooltip='Energiedaten mit fehlendem Standort suchen'
                        key='findEnergiedatenMitFehlendemStandort'
                        action='suche'
                        onAction={this.findEnergiedatenMitFehlendemStandort}
                    />
                </div>
                {this.state.junkData && this.renderJunkData()}
                {this.state.jsonObj && this.renderJsonObj()}
                {this.state.showSpinner && <WSpinner />}
            </div>
        );
    }

    findJunkData() {
        this.setState({ showSpinner: true }, () => {
            this.apiService.call('maintenance', { key3: 'findJunkData' }, (json: string, succ: boolean) => {
                this.setState({ showSpinner: false });
                let junkData;
                try {
                    junkData = JSON.parse(json);
                } catch (e) {
                    console.error(e, json);
                }
                if (junkData) {
                    this.setState({ junkData });
                    this.buildRegiCheckSql(junkData);
                }
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }

    cleanJunkData() {
        this.setState({ showSpinner: true }, () => {
            this.apiService.call('maintenance', { key3: 'cleanJunkData' }, (json: string, succ: boolean) => {
                this.setState({ showSpinner: false });
                if (succ) {
                    alert('Junk-Daten wurden gelöscht.');
                }
                let jsonObj;
                try {
                    jsonObj = JSON.parse(json);
                } catch (e) {
                    console.error(e, json);
                }
                if (jsonObj) {
                    console.log(jsonObj);
                    this.setState({ jsonObj });
                }
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }

    renderJunkData(): JSX.Element {
        const { junkData } = this.state;
        if (junkData) {
            return (
                <div>
                    {Object.keys(junkData).map((bereich: string) => <div>
                        <div style={{ fontWeight: 'bold', padding: 10, backgroundColor: 'lightgray' }}>{bereich} ({Object.keys(junkData[bereich]).length})</div>
                        <div style={{ marginLeft: 50 }}>
                            {Object.keys(junkData[bereich]).map((entity: string) => <div style={{ marginBottom: 10 }}>
                                <div style={{ fontWeight: 'bold', padding: 10 }}>{entity} ({junkData[bereich][entity].length})</div>
                                <div style={{ marginLeft: 50 }}>
                                    {junkData[bereich][entity].map((manda: string) => <div>{manda}</div>)}
                                </div>
                            </div>)}
                        </div>
                    </div>)}
                </div>
            );
        }
        return null;
    }

    buildRegiCheckSql(junkData: any) {
        Object.keys(junkData).forEach((bereich: string) => {
            const map: any = {};
            Object.keys(junkData[bereich]).forEach((entity: string) => {
                junkData[bereich][entity].forEach((manda: string) => map[manda] = 1);
            });
            if (Object.keys(map).length > 0) {
                const sql = `SELECT * FROM entity_registrierung WHERE ${bereich === 'admin' ? '' : `bereich_key = '${bereich}' AND`} mandant_key IN ('${Object.keys(map).join('\', \'')}')`;
                console.log(sql);
            }
        });
    }

    findEnergiedatenMitFehlendemStandort() {
        this.setState({ showSpinner: true }, () => {
            this.apiService.call('maintenance', { key3: 'findEnergiedatenMitFehlendemStandort' }, (json: string, succ: boolean) => {
                this.setState({ showSpinner: false });
                let jsonObj;
                try {
                    jsonObj = JSON.parse(json);
                } catch (e) {
                    console.error(e, json);
                }
                if (jsonObj) {
                    console.log(jsonObj);
                    this.setState({ jsonObj });
                }
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }

    renderJsonObj(): JSX.Element {
        return <div style={{ padding: 10, fontSize: '0.9em' }}>
            <pre style={{ fontFamily: 'Consolas' }}>
                {JSON.stringify(this.state.jsonObj, null, 4)}
            </pre>
        </div>
    }
}
